namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_borderwidth, {
		
		Border_width: {
			String: {
				width: '4rem',
				padding: {
					right: '1.7rem',
				},
			},
		},
		Border_width_wrap: {
			position: 'relative',
			'::after': {
				content: '"px"',
				position: 'absolute',
				right: '8px',
				top: '50%',
				transform: 'translateY(-50%)',
				pointerEvents: 'none',
				color: $mol_theme.shade,
				zIndex: 1,
			},
		},
		
	} )
	
}
